import React, { useState } from 'react';
import { migrateUserDataToWorkspace } from '../utils/workspaceMigration';

const WorkspaceMigration = ({ userId, otherUserId, onWorkspaceCreated }) => {
  const [migrating, setMigrating] = useState(false);
  const [result, setResult] = useState(null);

  const handleMigration = async () => {
    if (!window.confirm('Are you sure you want to migrate your data to a new shared workspace?')) {
      return;
    }

    setMigrating(true);
    try {
      const memberIds = [userId, otherUserId];
      const result = await migrateUserDataToWorkspace(
        userId,
        'Shared Bills Workspace',
        memberIds
      );

      setResult(result);
      
      if (result.success) {
        console.log('Workspace created with ID:', result.workspaceId);
        onWorkspaceCreated(result.workspaceId);
      }
    } catch (error) {
      setResult({
        success: false,
        message: `Migration failed: ${error.message}`
      });
    } finally {
      setMigrating(false);
    }
  };

  return (
    <div style={styles.container}>
      <h2>Data Migration</h2>
      <p>This will migrate your data to a new shared workspace.</p>
      
      <button 
        onClick={handleMigration}
        disabled={migrating}
        style={styles.button}
      >
        {migrating ? 'Migrating...' : 'Create Shared Workspace'}
      </button>

      {result && !result.success && (
        <div style={styles.error}>
          {result.message}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: '20px',
    maxWidth: '600px',
    margin: '0 auto',
    textAlign: 'center'
  },
  button: {
    padding: '10px 20px',
    fontSize: '16px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    marginBottom: '20px'
  },
  error: {
    marginTop: '10px',
    padding: '10px',
    backgroundColor: '#f8d7da',
    color: '#721c24',
    borderRadius: '4px'
  }
};

export default WorkspaceMigration; 